import { render, staticRenderFns } from "./CustomerTypeDetail.vue?vue&type=template&id=a5159f74&"
import script from "./CustomerTypeDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports